
import SEO from '../../components/SEO';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import PlatformSection from './components/PlatformSection';
import CommunityGrowthSection from './components/CommunityGrowthSection';
import ProgramSection from './components/ProgramSection';
import FloatingCTAButton from '../../components/feature/FloatingCTAButton';
import WhatsAppScrollPopup from '../../components/feature/WhatsAppScrollPopup';

export default function HomePage() {
  const jsonLd = {
    "@type": "Organization",
    "name": "Experiencia NEO",
    "description": "Transforma tu estrés en energía, claridad y propósito. Únete a la comunidad NEO y descubre tu máximo potencial con nuestro programa exclusivo de desarrollo personal.",
    "url": import.meta.env.VITE_SITE_URL || "https://example.com",
    "logo": "https://static.readdy.ai/image/eeb6f71c46431ac1fde6cad29ff61ccd/7b78518959f7d8974f440985704db8e7.png",
    "foundingDate": "2024",
    "founders": [
      {
        "@type": "Person",
        "name": "Adrián Rodríguez",
        "jobTitle": "COO y Co-Fundador",
        "description": "Dirección Creativa y Comunidad"
      },
      {
        "@type": "Person", 
        "name": "Diego Dubois",
        "jobTitle": "CEO y Co-Fundador",
        "description": "Visión Global y Estratégica"
      }
    ],
    "offers": {
      "@type": "Offer",
      "name": "NEO 365 - Acceso Total",
      "description": "Acceso total a una mejor versión de tí día a día. La experiencia completa de transformación personal.",
      "price": "19",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/LimitedAvailability",
      "validThrough": "2025-12-31"
    },
    "serviceType": "Personal Development",
    "areaServed": "ES",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Spanish"
    }
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="NEO - Experiencia de Transformación Personal"
        description="Transforma tu estrés en energía, claridad y propósito. Únete a la comunidad NEO y descubre tu máximo potencial con nuestro programa exclusivo de desarrollo personal."
        keywords="transformación personal, desarrollo personal, consciencia, bienestar, crecimiento personal, NEO, comunidad, prelanzamiento"
        canonical="/"
        ogTitle="NEO - Experiencia de Transformación Personal"
        ogDescription="Transforma tu estrés en energía, claridad y propósito. Únete a la comunidad NEO y descubre tu máximo potencial con nuestro programa exclusivo de desarrollo personal."
        ogType="website"
        ogUrl="/"
        twitterTitle="NEO - Experiencia de Transformación Personal"
        twitterDescription="Transforma tu estrés en energía, claridad y propósito. Únete a la comunidad NEO y descubre tu máximo potencial."
        jsonLd={jsonLd}
      />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <PlatformSection />
      <CommunityGrowthSection />
      <ProgramSection />
      <FloatingCTAButton />
      <WhatsAppScrollPopup />
    </div>
  );
}
